module.exports = __webpack_public_path__ + "static/media/comp-banner-drone.99eeefaf.svg";